
export enum MSG_TYPE_CHARGES {
    EXPENSE_NEW_ALERT = 'EXPENSE_NEW_ALERT',
    EXPENSE_NEW_EMAIL = 'EXPENSE_NEW_EMAIL',
}


export enum MSG_TYPE_CHARGES_SITUATION {
    EXPENSE_TREATED_ALERT = 'EXPENSE_TREATED_ALERT',
    EXPENSE_TREATED_EMAIL = 'EXPENSE_TREATED_EMAIL'
}

export enum MSG_TYPE_CHARGES_STATUS {
    EXPENSE_REFUND_APPROVED_ALERT = 'EXPENSE_REFUND_APPROVED_ALERT',
    EXPENSE_REFUND_APPROVED_EMAIL = 'EXPENSE_REFUND_APPROVED_EMAIL',
    EXPENSE_REFUND_REFUSED_ALERT = 'EXPENSE_REFUND_REFUSED_ALERT',
    EXPENSE_REFUND_REFUSED_EMAIL = 'EXPENSE_REFUND_REFUSED_EMAIL'
}

export enum MSG_TYPE_VERIFICATIONS { VERIFICATION_NEW_ALERT = 'VERIFICATION_NEW_ALERT', VERIFICATION_NEW_EMAIL = 'VERIFICATION_NEW_EMAIL' }

export enum MSG_TYPE_ANNOTATIONS {
    ANNOTATION_INTERVENTION_TYPE_INFORMATION_ALERT = 'ANNOTATION_INTERVENTION_TYPE_INFORMATION_ALERT',
    ANNOTATION_INTERVENTION_TYPE_INFORMATION_EMAIL = 'ANNOTATION_INTERVENTION_TYPE_INFORMATION_EMAIL',
    ANNOTATION_INTERVENTION_TYPE_INTERVENTION_ALERT = 'ANNOTATION_INTERVENTION_TYPE_INTERVENTION_ALERT',
    ANNOTATION_INTERVENTION_TYPE_INTERVENTION_EMAIL = 'ANNOTATION_INTERVENTION_TYPE_INTERVENTION_EMAIL',
    ANNOTATION_INTERVENTION_TYPE_URGENT_ALERT = 'ANNOTATION_INTERVENTION_TYPE_URGENT_ALERT',
    ANNOTATION_INTERVENTION_TYPE_URGENT_EMAIL = 'ANNOTATION_INTERVENTION_TYPE_URGENT_EMAIL'
}

export enum MSG_TYPE_RESERVATIONS {
    RESERVATION_NEW_ALERT = 'RESERVATION_NEW_ALERT',
    RESERVATION_NEW_EMAIL = 'RESERVATION_NEW_EMAIL',
    RESERVATION_PENDING_APPROVAL_ALERT = 'RESERVATION_PENDING_APPROVAL_ALERT',
    RESERVATION_PENDING_APPROVAL_EMAIL = 'RESERVATION_PENDING_APPROVAL_EMAIL',
    RESERVATION_APPROVED_ALERT = 'RESERVATION_APPROVED_ALERT',
    RESERVATION_APPROVED_EMAIL = 'RESERVATION_APPROVED_EMAIL',
    RESERVATION_REJECTED_ALERT = 'RESERVATION_REJECTED_ALERT',
    RESERVATION_REJECTED_EMAIL = 'RESERVATION_REJECTED_EMAIL'
}


export enum MSG_TYPE_REQUEST_VERIFICATIONS {
    REQUEST_VERIFICATION_NEW_ALERT = 'REQUEST_VERIFICATION_NEW_ALERT',
    REQUEST_VERIFICATION_NEW_EMAIL = 'REQUEST_VERIFICATION_NEW_EMAIL'
}

export enum MSG_TYPE_GPS_ALARM {
    ALARM_TRIGGER_ENTRY_AREA_ALERT = 'ALARM_TRIGGER_ENTRY_AREA_ALERT',
    ALARM_TRIGGER_ENTRY_AREA_EMAIL = 'ALARM_TRIGGER_ENTRY_AREA_EMAIL',
    ALARM_TRIGGER_ENTRY_AREA_SMS = 'ALARM_TRIGGER_ENTRY_AREA_SMS',
    ALARM_TRIGGER_EXIT_AREA_ALERT = 'ALARM_TRIGGER_EXIT_AREA_ALERT',
    ALARM_TRIGGER_EXIT_AREA_EMAIL = 'ALARM_TRIGGER_EXIT_AREA_EMAIL',
    ALARM_TRIGGER_EXIT_AREA_SMS = 'ALARM_TRIGGER_EXIT_AREA_SMS',
}

export enum MSG_TYPE_GPS_ALARM_SPEED {
    ALARM_TRIGGER_SPEED_ALERT = 'ALARM_TRIGGER_SPEED_ALERT',
    ALARM_TRIGGER_SPEED_EMAIL = 'ALARM_TRIGGER_SPEED_EMAIL',
    ALARM_TRIGGER_SPEED_SMS = 'ALARM_TRIGGER_SPEED_SMS',
}

export enum MSG_TYPE_GPS_ALARM_TOWING_AND_DISCONNECTION{
    ALARM_TRIGGER_TOWING_ALERT = 'ALARM_TRIGGER_TOWING_ALERT',
    ALARM_TRIGGER_TOWING_EMAIL = 'ALARM_TRIGGER_TOWING_EMAIL',
    ALARM_TRIGGER_TOWING_SMS = 'ALARM_TRIGGER_TOWING_SMS',
    ALARM_TRIGGER_UNPLUGED_ALERT = 'ALARM_TRIGGER_UNPLUGED_ALERT',
    ALARM_TRIGGER_UNPLUGED_EMAIL = 'ALARM_TRIGGER_UNPLUGED_EMAIL',
    ALARM_TRIGGER_UNPLUGED_SMS = 'ALARM_TRIGGER_UNPLUGED_SMS',
    ALARM_TRIGGER_STAY_IN_AREA_ALERT = 'ALARM_TRIGGER_STAY_IN_AREA_ALERT',
    ALARM_TRIGGER_STAY_IN_AREA_EMAIL = 'ALARM_TRIGGER_STAY_IN_AREA_EMAIL',
    ALARM_TRIGGER_STAY_IN_AREA_SMS = 'ALARM_TRIGGER_STAY_IN_AREA_SMS',
    ALARM_TRIGGER_STAY_OUT_AREA_ALERT = 'ALARM_TRIGGER_STAY_OUT_AREA_ALERT',
    ALARM_TRIGGER_STAY_OUT_AREA_EMAIL = 'ALARM_TRIGGER_STAY_OUT_AREA_EMAIL',
    ALARM_TRIGGER_STAY_OUT_AREA_SMS = 'ALARM_TRIGGER_STAY_OUT_AREA_SMS',
}

export enum MSG_TYPE_GPS_EXPENSE_FILE_IMPORT{
    EXPENSE_FILE_PROCESSED_NEW_EMAIL = 'EXPENSE_FILE_PROCESSED_NEW_EMAIL',
    EXPENSE_FILE_PROCESSED_NEW_ALERT = 'EXPENSE_FILE_PROCESSED_NEW_ALERT',
    EXPENSE_FILE_INVALID_NEW_EMAIL = 'EXPENSE_FILE_INVALID_NEW_EMAIL',
    EXPENSE_FILE_INVALID_NEW_ALERT = 'EXPENSE_FILE_INVALID_NEW_ALERT'
}

export enum MSG_TYPE_REMINDERS{
    REMINDER_VEHICLE_NEW_EMAIL = 'REMINDER_VEHICLE_NEW_EMAIL',
}

export enum MSG_TYPE_MAINTENANCES{
    SEND_MAINTENANCE_ATTACHMENTS_EMAIL = 'SEND_MAINTENANCE_ATTACHMENTS_EMAIL',
}